import CollectionContainer from '../containers/Collection';
const startPageSearch = () => {
    console.log('UNTUCKit : Template : PageSearchResults');
    new CollectionContainer();
};
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startPageSearch, { once: true });
}
else {
    startPageSearch();
}
